/*
 *
 * Do not edit directly
 * Generated on Thu, 24 Apr 2025 18:51:19 GMT
 *
 */

import PaletteIconCaretDown from '@telus-uds/palette-allium/build/rn/icons/CaretDown'
import PaletteIconCaretUp from '@telus-uds/palette-allium/build/rn/icons/CaretUp'
const theme = {
  appearances: {
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm' ] },
      tokens: {
        expandContentPaddingRight: 24,
        listMarginLeft: 6,
        titlePaddingLeft: 6
      }
    },
    { if: { expanded: true }, tokens: { icon: PaletteIconCaretUp } },
    {
      if: { focus: true },
      tokens: {
        iconOuterBorderColor: '#414547',
        iconOuterBorderGap: 4,
        iconOuterBorderWidth: 1
      }
    },
    {
      if: { pressed: true },
      tokens: {
        iconBackgroundColor: '#676e73',
        iconBorderColor: '#ffffff',
        iconColor: '#ffffff',
        iconOuterBorderGap: 4
      }
    }
  ],
  tokens: {
    contentBorderColor: 'transparent',
    contentMarginBottom: 0,
    contentPaddingBottom: 0,
    contentPaddingLeft: 16,
    dividerColor: '#b2b9bf',
    expandBaseBorderWidth: 0,
    expandContentPaddingBottom: 16,
    expandContentPaddingLeft: 16,
    expandContentPaddingRight: 16,
    expandContentPaddingTop: 16,
    expandIconContainerAlignItems: 'center',
    expandIconContainerBorder: 0,
    expandIconContainerBorderColor: 'rgba(0, 0, 0, 0)',
    expandIconContainerHeight: 32,
    expandIconContainerJustifyContent: 'center',
    expandIconContainerMarginX: 0,
    expandIconContainerMarginY: 12,
    expandIconContainerWidth: 32,
    expandTitleBorder: 0,
    expandTitleBorderColor: 'rgba(0, 0, 0, 0)',
    expandTitleColor: '#2c2e30',
    expandTitleFontName: 'HNforTELUSSA',
    expandTitleFontSize: 16,
    expandTitleFontWeight: '500',
    expandTitleLineHeight: 1.5,
    expandTitleMarginX: 4,
    expandTitleMarginY: 0,
    expandTitlePaddingLeft: 0,
    expandTitleUnderline: 'none',
    headerBackgroundColor: 'rgba(0, 0, 0, 0)',
    icon: PaletteIconCaretDown,
    iconBackgroundColor: 'transparent',
    iconBorderColor: '#676e73',
    iconColor: '#676e73',
    iconOuterBorderColor: 'transparent',
    iconOuterBorderGap: 0,
    iconOuterBorderWidth: null,
    listColor: '#414547',
    listFontName: 'HNforTELUSSA',
    listFontSize: 14,
    listFontWeight: '400',
    listLineHeight: 1.42857142857,
    listMarginBottom: 16,
    listMarginLeft: 32,
    mdContentPaddingBottom: 16,
    mdContentPaddingLeft: 48,
    orderedPadding: 0,
    titleColor: '#414547',
    titleFontSize: 14,
    titleLineHeight: 1.42857142857,
    titlePaddingLeft: 32,
    unorderedPadding: 12
  }
}
export default theme
